// extracted by mini-css-extract-plugin
module.exports = {"pageHeaderContainer":"pageHeaderContainer-2L18l"};